// import Vue from 'vue'
// import Vuex from 'vuex'
import apps from './modules/apps'
import training from './modules/training'
import user from './modules/user'

// Use Vuex
// Vue.use(Vuex)
import { createStore } from 'vuex'

const debug = process.env.NODE_ENV !== 'production'

// export default new Vuex.Store({
//   modules: {
//     user,
//     apps,
//     training
//   },
//   strict: debug
// })

export const store = createStore({
  state () {
    return {
      count: 1
    }
  },
  modules: {
    user,
    apps,
    training
  },
  strict: debug
})
